import {
  ITEM_TEMPLATE_ALL, ITEM_TEMPLATE_GET, ITEM_TEMPLATE_POST, ITEM_TEMPLATE_PUT, ITEM_TEMPLATE_DEL,
  ITEM_TEMPLATE_RESET, ITEM_TEMPLATE_LOADING, ITEM_TEMPLATE_ERROR,
} from '../types';
import api from '../../../utils/functions/api';

const BASE = `${process.env.REACT_APP_API_URL}/item-templates`;

export const itemTemplateAll = (params = {}) => async (dispatch) => {
  try {
    const { q = '', category = '', page = 1, limit = 50 } = params;
    const { data } = await api.get(`${BASE}?q=${q}&category=${category}&page=${page}&limit=${limit}`);
    dispatch({ type: ITEM_TEMPLATE_ALL, payload: data });
  } catch (error) {
    dispatch({ type: ITEM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const itemTemplateAllFlat = (params = {}) => async (dispatch) => {
  try {
    const { q = '', category = '' } = params;
    const { data } = await api.get(`${BASE}/all?q=${q}&category=${category}`);
    dispatch({ type: ITEM_TEMPLATE_ALL, payload: { rows: data, total: data.length } });
    return data;
  } catch (error) {
    dispatch({ type: ITEM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const itemTemplateGet = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`${BASE}/${id}`);
    dispatch({ type: ITEM_TEMPLATE_GET, payload: data });
  } catch (error) {
    dispatch({ type: ITEM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const itemTemplateCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: ITEM_TEMPLATE_LOADING });
    const { data } = await api.post(BASE, payload);
    dispatch({ type: ITEM_TEMPLATE_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: ITEM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const itemTemplateUpdate = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: ITEM_TEMPLATE_LOADING });
    const { data } = await api.patch(`${BASE}/${id}`, payload);
    dispatch({ type: ITEM_TEMPLATE_PUT, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: ITEM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const itemTemplateDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: ITEM_TEMPLATE_LOADING });
    await api.delete(`${BASE}/${id}`);
    dispatch({ type: ITEM_TEMPLATE_DEL, payload: { id } });
  } catch (error) {
    dispatch({ type: ITEM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const itemTemplateReset = () => async (dispatch) => {
  dispatch({ type: ITEM_TEMPLATE_RESET });
};
